import { Component, input, Input, OnInit } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-donut-chart',
  standalone: true,
  imports: [BaseChartDirective],
  templateUrl: './donut-chart.component.html',
  styleUrl: './donut-chart.component.scss',
})
export class DonutChartComponent implements OnInit {
  @Input() data: number[];
  @Input() labels: string[];
  @Input() preferredColors: string[];

  chartWidth = input<number>(300);
  chartCutout = input<number>(50);
  doughnutChartDatasets: ChartConfiguration<'doughnut'>['data']['datasets'] = [];

  doughnutChartOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: false,
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          usePointStyle: true,
          boxWidth: 8,
          boxHeight: 8,
          font: {
            family: 'yekan-bakh, "Courier New", Courier, monospace',
          },
        },
        rtl: true,
      },
      tooltip: {
        bodyFont: {
          family: 'yekan-bakh, "Courier New", Courier, monospace',
        },
        callbacks: {
          label: (tooltipItem) => {
            return tooltipItem.raw + '%';
          },
        },
      },
    },
    animation: true,
    layout: {
      padding: {
        top: 20,
      },
      autoPadding: true,
    },
  };

  ngOnInit(): void {
    this.labels = this.labels?.map((label) => {
      const l = 'CHART_' + label.toUpperCase();

      switch (l) {
        case 'CHART_BOND':
          return 'اوراق مشارکت';
        case 'CHART_CASH':
          return 'وجه نقد';
        case 'CHART_COMMODITY':
          return 'گواهی سپرده کالایی';
        case 'CHART_DEPOSIT':
          return 'سپرده بانکی';
        case 'CHART_FIVEBEST':
          return 'پنج سهم با بیشترین وزن';
        case 'CHART_FUNDUNIT':
          return 'واحد صندوق';
        case 'CHART_OTHER':
          return 'سایر دارایی‌ها';
        case 'CHART_STOCK':
          return 'سایر سهام';
        case 'CHART_GOLDBAR':
          return 'شمش';
        case 'CHART_GOLDCOIN':
          return 'سکه';
      }

      return label.toUpperCase();
    });
    this.doughnutChartDatasets = [
      {
        data: this.data,
        label: '',
        borderRadius: 10,
        backgroundColor: this.preferredColors,
      },
    ];

    this.doughnutChartOptions.cutout = this.chartCutout();
  }
}
